module.exports = __webpack_public_path__ + "static/media/dress-code-men2.384690e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dressCode/dress-code-men2.jpg
// module id = 701
// module chunks = 0